import React from "react";

import { ButtonGroupProps } from "./ButtonGroup.types";

import "./ButtonGroup.scss";
import Button from "../../atoms/Button/Button";
import { ButtonSizes, ButtonTypes } from "../../atoms/Button/Button.types";

const ButtonGroup: React.FC<ButtonGroupProps> = ({
  buttons,
  selectedIndex,
  updateIndex,
}) => {
  return (
    <div data-testid="ButtonGroup" className="mp-molecules-buttongroup--main">
      {buttons.map((button, index) => {
        return (
          <Button
            key={`button-group-${index}`}
            label={button}
            onClick={() => updateIndex(index)}
            type={ButtonTypes.neutral}
            primary={true}
            size={ButtonSizes.tiny}
            selected={index === selectedIndex}
          />
        );
      })}
    </div>
  );
};

export default ButtonGroup;
